import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import trovity from 'src/assets/images/trovity.svg'
import instagram from 'src/assets/Buy_Policy_Images/Instagram.svg'
import facebook from 'src/assets/Buy_Policy_Images/Facebook.svg'
import linkedIn from 'src/assets/Buy_Policy_Images/LinkedIn.svg'
import Dropdown from 'src/assets/images/Dropdown.svg'
import { CORPORATE_LINKS, PERSONAL_LINKS } from 'src/utils/constants/BuyPolicy'
import { COLORS } from 'src/utils/Themes/colors'
import { addScroll, removeScroll } from 'src/utils/commonMethods'

const Header = () => {
  const classes = useStyles()
  const [isProductsOpen, setIsProductsOpen] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)

  const openProducts = (event) => {
    setIsProductsOpen(true)
    setAnchorEl(event?.currentTarget)
    removeScroll()
  }

  const closeProducts = () => {
    setIsProductsOpen(false)
    setAnchorEl(null)
    addScroll()
  }

  return (
    <>
      <Menu
        id='productsMenu'
        anchorEl={anchorEl}
        open={isProductsOpen}
        onClose={closeProducts}
      >
        <div className={classes.productsContainer}>
          <div className={classes.productListContainer}>
            <span className={classes.productsTitle}>Corporate</span>
            <div className={classes.linksContainer}>
              {CORPORATE_LINKS?.map((corporateLink) => (
                <MenuItem
                  key={`corporateLink_${corporateLink?.label}`}
                  className={classes.menuItem}
                >
                  <a
                    href={corporateLink?.link}
                    target='_self'
                    className={classes.productLink}
                  >
                    {corporateLink?.label}
                  </a>
                </MenuItem>
              ))}
            </div>
          </div>

          <div className={classes.productListContainer}>
            <span className={classes.productsTitle}>Personal</span>
            <div className={classes.linksContainer}>
              {PERSONAL_LINKS?.map((personalLink) => (
                <MenuItem
                  key={`personalLink_${personalLink?.label}`}
                  className={classes.menuItem}
                >
                  <a
                    href={personalLink?.link}
                    target='_self'
                    className={classes.productLink}
                  >
                    {personalLink?.label}
                  </a>
                </MenuItem>
              ))}
            </div>
          </div>
        </div>
      </Menu>

      <div className={`component-container ${classes.container}`}>
        <div className={`component-element ${classes.header}`}>
          <div className={classes.headerContainer}>
            <div className={classes.trovityImageContainer}>
              <a href={`${process?.env?.REACT_APP_HOME_URL}`} target='_self'>
                <img
                  src={trovity}
                  className={classes.imageTrovity}
                  alt='Trovity Logo'
                />
              </a>
            </div>
            <div className={classes.headerContent}>
              <div className={classes.headerContainerAction}>
                <span
                  className={classes.headerAction}
                  onClick={openProducts}
                  id='products'
                >
                  Products <img src={Dropdown} alt='Dropdown' />
                </span>
              </div>
              <div className={classes.headerContainerAction}>
                <a
                  href={`${process?.env?.REACT_APP_HOME_URL}/our-vision/`}
                  target='_self'
                  className={classes.headerField}
                >
                  <span className={classes.headerAction}>Company</span>
                </a>
              </div>
              <div className={classes.headerContainerAction}>
                <a
                  href={`${process?.env?.REACT_APP_HOME_URL}/blog/`}
                  target='_self'
                  className={classes.headerField}
                >
                  <span className={classes.headerAction}>Knowledge</span>
                </a>
              </div>
              <div className={classes.headerContainerAction}>
                <a
                  href={`${process?.env?.REACT_APP_HOME_URL}/claim/`}
                  target='_self'
                  className={classes.headerField}
                >
                  <span className={classes.headerAction}>Claim</span>
                </a>
              </div>

              <div className={classes.socialMediaIconsContainer}>
                <a
                  href='https://www.linkedin.com/company/trovity-insuretech/?originalSubdomain=in'
                  target='_self'
                  className={classes.socialMediaIcon}
                >
                  <img
                    src={linkedIn}
                    className={classes.imageActions}
                    alt='Linked-In'
                  />
                </a>
                <a
                  href='https://www.instagram.com/trovityinsurance/'
                  target='_self'
                  className={classes.socialMediaIcon}
                >
                  <img
                    src={instagram}
                    className={classes.imageActions}
                    alt='Instagram'
                  />
                </a>
                <a
                  href='https://www.facebook.com/TrovityInsurance/'
                  target='_self'
                  className={classes.socialMediaIcon}
                >
                  <img
                    src={facebook}
                    className={classes.imageActions}
                    alt='Facebook'
                  />
                </a>
              </div>
              <div className={classes.buttonsContainer}>
                <a
                  href={`${process?.env?.REACT_APP_LANDING_URL}/individual/dashboard/`}
                  target='_self'
                  className={classes.logInButton}
                >
                  Log In
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Header
const useStyles = makeStyles({
  container: {
    boxShadow: '0px 0px 10px 0px #00000033',
    borderBottom: '1px solid #00000033',
    flexDirection: 'row',
  },
  header: {
    padding: '0 !important',
  },
  headerContainer: {
    // backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  trovityImageContainer: {
    display: 'flex',
    maxHeight: '50px',
  },
  imageTrovity: {
    // width: '150px',
    // height: '30px',
    width: '175px',
    padding: '5px 0',
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media only screen and (max-width: 1024px)': {
      flexWrap: 'wrap',
    },
  },
  headerContainerAction: {
    padding: '10px 20px',
    borderRight: '1px solid #e7d7d7',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '60px',
  },
  headerAction: {
    fontSize: '14px',
    color: '#333333',
    cursor: 'pointer',
    // fontWeight: 'bold',
  },
  socialMediaIconsContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 20px',
    borderRight: '1px solid #e7d7d7',
    gap: '15px',
    justifyContent: 'center',
    height: '60px',
  },
  socialMediaIcon: {
    display: 'flex',
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    textTransform: 'none',
    height: '30px',
    paddingRight: '0',
  },
  productsContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: '20px',
    gap: '10px',
  },
  productListContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  productsTitle: {
    color: COLORS.DARK_PINK,
    textTransform: 'uppercase',
    padding: '0 16px',
  },
  linksContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  productLink: {
    textDecoration: 'unset',
    color: COLORS.BLACK,
    '&:hover': {
      textDecoration: 'underline',
      color: COLORS.DARK_PINK,
    },
  },
  menuItem: {
    boxShadow: 'unset',
    '&:hover': {
      backgroundColor: 'unset !important',
    },
  },
  logInButton: {
    border: `2px solid ${COLORS.DARK_PINK}`,
    padding: '0 25px',
    color: COLORS.DARK_PINK,
    textDecoration: 'unset',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '30px',
    fontWeight: 'bold',
  },
  headerField: {
    textDecoration: 'none',
  },
})
